module.exports = __webpack_public_path__ + "img/other_location.d58e4e97.svg";